import { AxiosRequestConfig } from "axios";
import { v4 as uuidv4 } from "uuid";

import { RequestManager } from "./index";

const baseUrl = process.env.BIG_FLIP_GATEWAY_BASE_URL;
const header = "Correlation-ID";

/**
 * RequestManager for the Kong gateway (`BIG_FLIP_GATEWAY_BASE_URL`). Every call
 * carries a fresh `correlation-id` header for tracing; callers can still override
 * it via `customHeaders`.
 */
export class APGatewayRequestManager extends RequestManager {
  async get<Response = any>(
    endpoint: string,
    params: Record<string, any> = {},
    customHeaders: Record<string, any> = {},
    additionalConfig: AxiosRequestConfig = {}
  ): Promise<Response> {
    return super.get<Response>(endpoint, params, { [header]: uuidv4(), ...customHeaders }, additionalConfig);
  }

  async post<Response = any>(
    endpoint: string,
    data: any = {},
    customHeaders: Record<string, any> = {},
    additionalConfig: AxiosRequestConfig = {}
  ): Promise<Response> {
    return super.post<Response>(endpoint, data, { [header]: uuidv4(), ...customHeaders }, additionalConfig);
  }

  async put<Response = any>(
    endpoint: string,
    data: any = {},
    customHeaders: Record<string, any> = {},
    additionalConfig: AxiosRequestConfig = {}
  ): Promise<Response> {
    return super.put<Response>(endpoint, data, { [header]: uuidv4(), ...customHeaders }, additionalConfig);
  }
}

const request = new APGatewayRequestManager(baseUrl);

export default request;
